(ns frontend.ui.component.percentage-layout.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [garden.color :refer [transparentize]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn row
  [{:keys [justify-content align-items]
    :or   {justify-content "center"
           align-items     "top"}}]
  {:display         "flex"
   :width           "100%"
   :align-items     align-items
   :justify-content justify-content
   :position        "sticky"
   :top             "0"
   :background      (theme/color [:palette :transparent])})

(defn child
  [flex-basis]
  {:overflow-wrap "anywhere"
   :padding       "0 16px 0 0"
   :flex-basis    (if (number? flex-basis)
                    (str flex-basis "%")
                    flex-basis)})
